import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Tag } from "primereact/tag";
import useUserStore from "../../utils/storeApp";
import { Column } from "primereact/column";
import CallAPI from "../../services/apiCalls";
import { UploadStatus, UploadType } from "../../utils/enums";
import $ from "jquery";
import useDragScroll from "../../hooks/useDragScroll";

const ListUploadStatus = () => {
  const { userRole, userToken, SetSharedObject, userSession } = useUserStore(
    (state) => ({
      userRole: state.userRole,
      userToken: state.userToken,
      SetSharedObject: state.SetSharedObject,
      userSession: state.userSession,
    })
  );
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [processing, SetProcessing] = useState(false);
  const [userObj, setUserObj] = useState([]);
  const [globalFilter, setGlobalFilter] = useState(" ");
  const navigate = useNavigate();
  const firstFocusRef = useRef(null);
  const tableContainerRef = useRef(null);
  useDragScroll(tableContainerRef, [userObj]);

  useEffect(() => {
    const modalEl = document.getElementById("DeleteUploadModal");
    if (!modalEl) return;
    const onShown = () => setTimeout(() => firstFocusRef.current?.focus(), 50);
    modalEl.addEventListener("shown.bs.modal", onShown);
    return () => modalEl.removeEventListener("shown.bs.modal", onShown);
  }, []);

  const resultsClick = (obj) => {
    SetSharedObject("UploadStatusResult", obj);
    navigate("/upload-summary");
  };

  useEffect(() => {
    getStausUploads();
  }, []);

  const getStausUploads = async () => {
    setSelectedProducts([]);
    SetProcessing(true);
    let call = "/uploadStatus/GetUploadStatus";
    const res = await CallAPI(call, false, "get", userToken);
    SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetProcessing(false);
      let tempObj = [];
      let array = res.data.data;
      let uName = "";
      if (
        userRole !== "SES ADMINISTRATOR" &&
        userRole !== "SYSTEMADMINISTRATOR"
      ) {
        let uNameDisplay = userSession.preferred_username.split("|");
        uName = uNameDisplay[0];
      }
      array.forEach((element) => {
        if (
          userRole !== "SES ADMINISTRATOR" &&
          userRole !== "SYSTEMADMINISTRATOR" &&
          uName === element.startedBy
        ) {
          tempObj.push(element);
        } else if (
          userRole === "SES ADMINISTRATOR" ||
          userRole === "SYSTEMADMINISTRATOR"
        ) {
          tempObj.push(element);
        }
      });
      buildObj(tempObj);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };

    const deleteRecords = async () => {
    SetProcessing(true);
    const temp = [];
    for (const elem of selectedProducts) {
        temp.push({
            Key: elem.id,
            Value: elem.fileName,
        });
    }
    let delUsers = JSON.stringify(temp);
    let call = "/uploadStatus/DeleteUploadStatus";
    const res = await CallAPI(call, delUsers, "post", userToken);
    SetSharedObject("ResponseCode", res.code);
    setSelectedProducts([]);
    if (res.status === "SUCCESS") {
      if (res.data.data?.errorList?.messages?.length > 0) {
        let msg = res.data.data.errorList?.messages;
        let str = "<div>";
        for (let el of msg) {
          str += `${el}`;
        }
        str += "</div>";
      } else {
        getStausUploads();
      }
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };

  const buildObj = (obj) => {
    let tempObj = [];
    for (const row of obj) {
      let statusColor = "danger";
      if (row.status === UploadStatus.Failed) {
        statusColor = (
          <Tag severity={"danger"}>
            Failed <i className="bi bi-exclamation-triangle-fill" aria-hidden="true"></i>
          </Tag>
        );
      } else if (row.status === UploadStatus.Completed) {
        statusColor = <Tag severity={"success"}>Completed</Tag>;
      } else if (row.status === UploadStatus.CompletedWithErrors) {
        statusColor = <Tag severity={"danger"}>Completed with errors</Tag>;
      } else if (row.status === UploadStatus.Queued) {
        statusColor = <Tag severity={"warning"}>Queued</Tag>;
      } else {
        statusColor = <Tag severity={"info"}>In Progress</Tag>;
      }

      row.uploadStatus = statusColor;
      tempObj.push(row);
    }
    setUserObj(tempObj);
  };

  const isRowSelectable = (r) => {
    return (
      r.status === UploadStatus.Failed ||
      r.status === UploadStatus.Completed ||
      r.status === UploadStatus.CompletedWithErrors ||
      r.status === UploadStatus.Queued
    );
  };

  const reportSummary = (rowData) => {
    if (
      rowData.status === UploadStatus.Failed ||
      rowData.status === UploadStatus.Completed ||
      rowData.status === UploadStatus.CompletedWithErrors
    ) {
      return (
        <>
        <button
            type="button"
            className="btn btn-link p-0 sp-margin17"
            aria-label={`View upload report for ${rowData.fileName || "this file"}`}
            onClick={() => resultsClick(rowData)}
         >
          <i
            className={"bi bi-file-earmark-text text-size9"}
            aria-hidden="true"
          ></i>
          </button>
        </>
      );
    } else {
      return null;
    }
  };

    const uploadTypeMap = {
        [UploadType.AddOrganizations]: "Organization",
        [UploadType.AddOrganizationEmails]: "Organization Email",
        [UploadType.DeleteOrganizationEmails]: "Delete Organization Email",
        [UploadType.AddUsers]: "Add User",
        [UploadType.DeleteUsers]: "Delete User",
    };

    const getUploadTypeDisplay = (dt) =>
        uploadTypeMap[dt.uploadType] ?? "-";

  const formatStartDate = (dt) => {
    return dt.startDate ? new Date(dt.startDate).toLocaleString() : null;
  };

  const formatEndDate = (dt) => {
    return dt.endDate ? new Date(dt.endDate).toLocaleString() : null;
  };

  const formatCreateDate = (dt) => {
    return dt.dateCreated ? new Date(dt.dateCreated).toLocaleString() : null;
  };

  function maskMailBoxSize(dt) {
    var i = !dt.fileSize
      ? 0
      : Math.floor(Math.log(dt.fileSize) / Math.log(1024));
    return (
      +(dt.fileSize / Math.pow(1024, i)).toFixed(2) * 1 +
      " " +
      ["B", "kB", "MB", "GB", "TB"][i]
    );
  }

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

    const toggleModal = (modalId, action) => {
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
        $(`#${modalId}`).modal(action); 
    };

  return (
    <main className="ListUploadStatus">
    <div className="HeaderTools">
      <header className="ht-6">
        <div className="spacer-inline">
           <h4 className="title-label3">List</h4>
        </div>
        <div className="mid-header-bar">
          <label htmlFor="uploadSearch" className="sr-only">Search upload records</label>
          <input
            id="uploadSearch"
            className="form-control w-md2 ht-5 spacer-inline spacer-margin6 shade-2"
            type="search"
            aria-label="Search upload records"
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Search"
          />
          <button
            className="btn btn-outline-dark sp-margin5 btn-reports-sm"
            aria-label="Refresh upload status list"
            onClick={(e) => {
              getStausUploads();
            }}
          >
            <i className="bi bi-arrow-clockwise" aria-hidden="true"></i>
          </button>
        </div>
      </header>
    </div>
      {userObj.length === 0 ? (
        <div className="empty-grid" rol="status" aria-live="polite" aria-atomic="true">
          There are currently no search results.
        </div>
      ) : (
        <section className="grid-layout" aria-label="Upload status records">
          <div ref={tableContainerRef} className="drag-scroll-table">
            <DataTable
              value={userObj}
              aria-label="Upload results list table"
              paginator
              rows={10}
              rowsPerPageOptions={[10, 25, 50]}
              tableStyle={{ minWidth: "50rem" }}
              dataKey="id"
              paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
              currentPageReportTemplate="{first} to {last} of {totalRecords}"
              selectionMode="single"
              selection={selectedProducts}
              onSelectionChange={(e) => {
                setSelectedProducts(e.value);
              }}
              columnResizeMode="expand"
              resizableColumns
              globalFilter={globalFilter}
              isDataSelectable={(e) => isRowSelectable(e.data)}
              rowClassName={(rowData) =>
                rowData.status === "In Progress" ? "in-progress-row" : ""
              }
              selectionAutoFocus={false}
              sortField="dateCreated"
              sortOrder={-1}
            >
              <Column
                selectionMode="multiple"
                className="w-s"
                pt={{ headerCheckbox: { box: { 'aria-label': 'Select all rows' } } }}
              ></Column>
              <Column
                field="fileName"
                header="File Name"
                className="truncate"
                sortable
              ></Column>
              <Column
                field="dateCreated"
                header="Date Created"
                className="w-md2"
                sortable
                body={formatCreateDate}
              ></Column>
              <Column
                field="uploadType"
                header="Upload Type"
                className="w-md1"
                sortable
                body={getUploadTypeDisplay}
              ></Column>
              <Column field="startedBy" header="Started By" sortable></Column>
              <Column
                field="startDate"
                header="Start Date"
                className="w-md2"
                sortable
                body={formatStartDate}
              ></Column>
              <Column
                field="endDate"
                header="End Date"
                className="w-md2"
                sortable
                body={formatEndDate}
              ></Column>
              <Column
                field="uploadStatus"
                header="Status"
                className="w-md2"
                sortable
              ></Column>
              <Column
                field="fileSize"
                header="Size"
                className="w-md4"
                sortable
                body={maskMailBoxSize}
              ></Column>
              <Column
                field="organizationName"
                header="Organization"
                sortable
              ></Column>
              <Column
                body={reportSummary}
                field="report"
                header="Report"
                sortable
              ></Column>
            </DataTable>
          </div>
          <div className="paging">
            <div className="spacer-inline spacer-margin9">
              <button
                type="button"
                className="btn btn-outline-secondary"
                disabled={selectedProducts.length === 0}
                aria-label="Delete selected upload records"
                onClick={() => toggleModal('DeleteUploadModal', 'show')}
              >
                Delete
              </button>
            </div>
          </div>

          <div className="modal fade" 
            id="DeleteUploadModal" 
            data-backdrop="static"  
            tabIndex="-1" 
            role="dialog" 
            aria-labelledby="delete-uploadconfirm-title"
            aria-describedby="deleteUploadModalDesc"
            aria-modal="true"
          >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3 className="modal-title" id="delete-uploadconfirm-title">Delete Confirmation</h3>
                            <button
                                type="button"
                                className="close"
                                aria-label="Close delete upload confirmation"
                                onClick={() => toggleModal('DeleteUploadModal', 'hide')}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                           <p id="deleteUploadModalDesc" className="sr-only">
                                Confirm or cancel permanent deletion of the selected upload records.
                           </p>
                            <p 
                                className="ctr"
                                ref={firstFocusRef}
                                tabIndex="-1"
                            >
                                Are you sure you want to delete <strong>{selectedProducts.length}</strong> selected uploaded file{selectedProducts.length !== 1 ? "s" : ""}? This action cannot be undone.
                            </p>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-success"
                                aria-label={`Confirm deletion of ${selectedProducts.length} file${selectedProducts.length !== 1 ? "s" : ""}`}
                                onClick={() => {
                                  toggleModal('DeleteUploadModal', 'hide');
                                  deleteRecords();
                                }}
                            >
                                Confirm
                            </button>
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() => toggleModal('DeleteUploadModal', 'hide')}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>

      )}
      {processing && (
        <div 
            className="loader-container" 
            role="status" 
            aria-live="polite" 
            aria-atomic="true"
            aria-labelledby="list-upload-loader"
        >
          <div className="spinner" aria-hidden="true"></div>
          <div className="loading-text" id="list-upload-loader">{loadingText}</div>
        </div>
      )}
    </main>
  );
};

export default ListUploadStatus;
